import { z } from 'zod';
import type { TFunction } from 'i18next';

const editCardFormSchema = (t: TFunction) => {
  const required = t('common.requiredField');

  return z.object({
    cardNumber: z.string().nonempty({ message: required }),
    cardholderName: z.string().nonempty({ message: required }),
    templateName: z.string().nonempty({ message: required }),
  });
};

export { editCardFormSchema };
